
export default {

    async setLayout({ commit }, layout) {
        commit('setLayout',layout)
    }
}
